import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
export const payrollAgreementSearch = listSearchSchema({
  searchString: z.string().optional().catch(undefined),
  name: z.string().optional().catch(undefined),
  initialDate: z.string().optional().catch(undefined),
  finalDate: z.string().optional().catch(undefined),
  tenant: z.string().optional().catch(undefined),
});
export const payrollAgreementDetailSearch = z.object({
  sheet: z.string().optional().catch(undefined),
});
